<template>
<div class="pa-body">

    <div class="" v-if="general">
        <div class="flex align-center mb20">
            <div class="f18 flex-fill">Datos Generales</div>
            <i class="options icon-dots-vertical" @click="Options([
                //{text: 'Ambiente de Certificación', function: () => {modalCertification = {sets: []} }, if: !general.shared_folios && Auth.role == 'admin', icon: 'cog'},
                {text: 'Ambiente de Certificación de Factura', function: () => {modalCertificationFactura = {sets: [], PeriodoTributarioVenta: {}, PeriodoTributarioCompra: {}, generateSobre: true, generateSaleBook: true, generatePurchaseBook:true } }, if: !!(!general.shared_folios && Local.modules.module_sii_factura), icon: 'cog'},
                {text: 'Usar Datos de Franquicia', function: () => {UseSharedFolios(true)}, if: sharedFoliosAvailable && !general.shared_folios, icon: 'link'},
                {text: 'Usar Datos Propios', function: () => {UseSharedFolios(false)}, if: sharedFoliosAvailable && !!general.shared_folios, icon: 'unlink'},
                {text: 'Cargar certificado digital', function: () => {modalCert = {pass: '', file: null} }, if: !general.shared_folios, icon: 'upload'},
                {text: 'Editar Datos', function: () => {OpenGeneral()}, icon: 'edit' },
            ])"></i>
        </div>

        <div class="section mb20">

            <div v-if="general.shared_folios" class="flex align-center">
                <avatar class="mr10"
                icon="link"
                :color="Util.baseColors.yellow">
                </avatar>
                <div>
                    <div class="bold">Usando datos de Franquicia</div>
                    <div class="secondary-text">Se usarán los datos generales y el certificado de {{ franchise.name }}</div>
                </div>
            </div>

            <div v-else>
                <div class="bold">Razón Social</div>
                <div class="mb15">{{general.sii_name ? general.sii_name : '-'}}</div>

                <div class="bold">RUT Empresa</div>
                <div class="mb15">{{general.sii_rut ? general.sii_rut : '-'}}</div>

                <div class="flex align-center">
                    <avatar class="mr10"
                    :icon="general.cert_at ? 'key' : 'cross'"
                    :color="general.cert_at ? Util.baseColors.blue : Util.baseColors.red">
                    </avatar>
                    <div>
                        <!--<div class="bold">Certificado</div>-->
                        <div v-if="general.cert_at" class="cblue">Certificado cargado el {{Util.Date(general.cert_at, 'dddd D [de] MMMM, YYYY')}}</div>
                        <div v-else class="cred">No hay certificado para firmar documentos electrónicos</div>
                        <div v-if="general.expires_at" class="secondary-text">Expira el {{Util.Date(general.expires_at, 'dddd D [de] MMMM, YYYY')}}</div>
                    </div>
                </div>
            </div>

            

            <!--
            <label class="input-style mb5">
                <input type="checkbox" v-model="general.auto_sign_boleta">Firma automáticamente<div class="checkmark"></div>
            </label>
            -->
            <!--
            <div v-show="!general.shared_folios" class="well">
                <div class="bold">Certificado</div>
                <div v-if="general.cert_at" class="cblue">Cargado el {{Util.Date(general.cert_at, 'dddd D [de] MMMM, YYYY')}}</div>
                <div v-else class="cred">No se ha cargado un certificado para firmar documentos electrónicos</div>
            </div>
            -->

        </div>

    </div>

    <div v-if="general && Local.modules.module_sii_boleta">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Boletas</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => { modalSignature = {folio: null} }, if: !general.shared_folios, icon: 'plus'},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosBoleta.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosBoleta" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <!-- <div v-if="folio.id == general.id_active_folio" class="secondary-text mb5"><i class="icon icon-circle-check"></i> Se están usando estos folios para timbrar boletas</div>-->
                        <div class="bold"><i v-if="folio.id == general.id_active_folio" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                         <!--<div class="secondary-text"><span class="bold">Folios: </span>{{(folio.folio_finish - folio.folio_current + 1)}} disponible de {{(folio.folio_finish - folio.folio_start + 1)}} (desde el {{folio.folio_start}} hasta el {{folio.folio_finish}}, actualmente en el {{folio.folio_current}})</div>-->
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`, icon: 'trash'},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio && folio.id != general.id_active_folio && folio.folio_current <= folio.folio_finish, icon: 'check'}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <div v-if="general && Local.modules.module_sii_factura">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Facturas</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => {modalSignature = {folio: null} }, if: !general.shared_folios, icon: 'plus'},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosFacturas.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosFacturas" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio_factura ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <div class="bold"><i v-if="folio.id == general.id_active_folio_factura" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`, icon: 'trash'},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio_factura && folio.id != general.id_active_folio_factura && folio.folio_current <= folio.folio_finish, icon: 'check'}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <div v-if="general && Local.modules.module_sii_factura">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Nota de Crédito</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => {modalSignature = {folio: null} }, if: !general.shared_folios, icon: 'plus'},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosNC.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosNC" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio_nc ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <div class="bold"><i v-if="folio.id == general.id_active_folio_nc" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`, icon: 'trash'},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio_nc && folio.id != general.id_active_folio_factura && folio.folio_current <= folio.folio_finish, icon: 'check'}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <div v-if="general && Local.modules.module_sii_factura">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Nota de Débito</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => {modalSignature = {folio: null} }, if: !general.shared_folios, icon: 'plus'},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosND.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosND" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio_nd ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <div class="bold"><i v-if="folio.id == general.id_active_folio_nd" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`, icon: 'trash'},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio_nd && folio.id != general.id_active_folio_nd && folio.folio_current <= folio.folio_finish, icon: 'check'}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <div v-if="general && Local.modules.module_sii_factura">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Guía de Despacho</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => {modalSignature = {folio: null} }, if: !general.shared_folios, icon: 'plus'},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosDG.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosDG" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio_dg ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <div class="bold"><i v-if="folio.id == general.id_active_folio_dg" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`, icon: 'trash'},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio_dg && folio.id != general.id_active_folio_dg && folio.folio_current <= folio.folio_finish, icon: 'check'}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <div v-if="general && Local.modules.module_sii_factura">

        <div class="mb20 flex align-center">
            <div class="f18 flex-fill">Folios - Factura Exenta</div>
            <i class="options icon-dots-vertical" @click="Options([
                {text: 'Ingresar Folios', function: () => {modalSignature = {folio: null} }, if: !general.shared_folios},
            ])" v-show="!general.shared_folios"></i>
        </div>

        <div v-if="!general.shared_folios">
            <div class="secondary-text mt10 ta-center" v-if="!foliosFacturasExenta.length">No hay folios ingresados</div>
            <div class="section mb10" v-for="folio in foliosFacturasExenta" :key="folio.id" v-tooltip="`${folio.id == general.id_active_folio_factura_exenta ? 'Se están usando estos folios. ' : ''}Folio actual ${folio.folio_current}`">
                <div class="fill flex align-center">
                    <div class="flex column flex-fill">
                        <div class="bold"><i v-if="folio.id == general.id_active_folio_factura_exenta" class="icon icon-circle-check cpurple mr5"></i>Folios {{folio.folio_start}} - {{folio.folio_finish}}</div>
                        <div class="secondary-text"><span class="bold">Emisor: </span>{{folio.sii_name}} {{folio.sii_rut}}</div>
                        <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(folio.created_at)}}</div>
                        <div class="secondary-text"><span class="bold">Autorizado: </span>{{Util.Date(folio.authorization_date)}}</div>
                    </div>
                    <div class="ta-right">
                        <div class="bold">{{(folio.folio_finish - folio.folio_current + 1)}}/{{(folio.folio_finish - folio.folio_start + 1)}}</div>
                        <div class="secondary-text">Disponibles</div>
                    </div>
                    <i class="options icon-dots-vertical ml5" @click="Options([
                        {text: 'Eliminar Folios', class: 'error-color', function: () => {DeleteFolios(folio.id, folio.document_type)}, confirm: `¿Eliminar folios? Puede generar errores con el SII si es que se usaron algunos folios y se vuelven a ingresar estos folios`},
                        {text: 'Usar estos folios', function: () => {SetActiveFolios(folio.id, folio.document_type)}, if: general.id_active_folio_factura_exenta && folio.id != general.id_active_folio_factura_exenta && folio.folio_current <= folio.folio_finish}
                    ])"></i>
                </div>
            </div>
        </div>
        <div class="secondary-text mt10 ta-center" v-else>Se utilizarán los folios de la Franquicia</div>

    </div>

    <modal v-model="modalGeneral" dir="right" :modalClass="['fill borderless', 'right md h100']" title="Datos Generales">
        <div v-if="modalGeneral" class="pa20">

            <div v-if="general.shared_folios" class="well mini secondary-text mb15">Se usarán algunos datos de la Franquicia</div>

            <input-image v-if="Local && Local.type == 'LOCAL'"
            label="Logo"
            v-model="modalGeneral.logotype"
            path="logos/" 
            class="mb15">
            </input-image>

            <input-field
            v-show="!general.shared_folios"
            v-model="modalGeneral.sii_name"
            label="Razón Social"
            class="mb15">
            </input-field>

            <input-field
            v-show="!general.shared_folios"
            v-model="modalGeneral.sii_rut"
            label="RUT Empresa"
            class="mb15">
            </input-field>

            <input-field
            v-show="!general.shared_folios"
            v-model="modalGeneral.sii_giro"
            label="Giro"
            class="mb15">
            </input-field>

            <input-field
            v-model="modalGeneral.sii_address"
            label="Dirección"
            class="mb15">
            </input-field>

            <input-select
            :canType="true"
            :items="regionalAddresses"
            v-model="modalGeneral.sii_regional_address"
            label="Dirección Regional"
            class="mb15">
            </input-select>

            <input-field
            v-model="modalGeneral.sii_branch_office"
            label="Dirección Sucursal"
            class="mb15">
            </input-field>

            <div class="hs">
                <input-field
                v-show="!general.shared_folios"
                v-model="modalGeneral.sii_resol_number"
                label="Número de Resolución (Boleta)"
                class="mb15">
                </input-field>

                <input-field
                v-show="!general.shared_folios"
                v-model="modalGeneral.sii_resol_date"
                label="Fecha de Resolución (Boleta)"
                placeholder="YYYY-MM-DD"
                class="mb15">
                </input-field>
            </div>

            <div class="hs">
                <input-field
                v-show="!general.shared_folios"
                v-model="modalGeneral.sii_resol_number_factura"
                label="Número de Resolución (Factura)"
                class="mb15">
                </input-field>

                <input-field
                v-show="!general.shared_folios"
                v-model="modalGeneral.sii_resol_date_factura"
                label="Fecha de Resolución (Factura)"
                placeholder="YYYY-MM-DD"
                class="mb15">
                </input-field>
            </div>

            <!-- ACTIVIDADES ECONÓMICAS -->

            <div class="flex align-center mb20">
                <div class="flex-fill">
                    <span class="bold">Actividades económicas</span>
                    <div class="secondary-text">
                        Registro de actividades económicas utilizadas comúnmente. Máximo 4.
                    </div>
                </div>

                <input-select class="ml5"
                inputClass="secondary"
                v-model="modalGeneral.actecoSelected"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddActeco()"
                :items="actecos"
                canType="search"
                v-tooltip="'Añadir actividad económica'"
                icon="plus">
                </input-select>
            </div>

            <div class="flex well mb20" 
            v-for="(name, index) in modalGeneral.actecos" :key="index">
                <div class="flex-fill">
                    <div class="bold">{{name}}</div>
                </div>
                <i class="options icon-trash" @click.stop="modalGeneral.actecos.splice(index, 1)"></i>
            </div>

            <!-- Settings Boleta -->

            <div class="separator mt20 mb20"></div>

            <div class="f18 mb20">Configuración Boleta</div>

            <input-select
            :items="[{text: 'No incluir', value: 'NO'},{text: 'Incluir siempre', value: 'ALWAYS'}, {text: 'Incluir sólo reparto interno', value: 'INTERNAL_ONLY'}]"
            v-model="modalGeneral.boleta_include_delivery"
            label="Incluir costo de reparto en boletas"
            class="mb20">
            </input-select>

            <div class="flex align-center mb20">
                <div class="flex-fill">
                    <span class="bold">Métodos de Pago Restringidos</span>
                    <div class="secondary-text">
                        Métodos de pago restringidos para emitir boletas.
                    </div>
                </div>

                <input-select class="ml5"
                inputClass="secondary"
                v-model="modalGeneral.paymentMethodSelected"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddPaymentMethod($event, 'banned_payment_methods')"
                :items="paymentsMethods"
                canType="search"
                v-tooltip="'Añadir método de pago'"
                icon="plus">
                </input-select>
            </div>

            <div class="flex align-center well mb20" 
            v-for="(method, index) in modalGeneral.banned_payment_methods" :key="`restricted-${index}`">
                <div class="bold flex-fill">{{dictMethods[method]? dictMethods[method] : method}}</div>
                <i class="options icon-trash" @click.stop="modalGeneral.banned_payment_methods.splice(index, 1)"></i>
            </div>

            <div class="flex align-center mb10">
                <div class="flex-fill">
                    <span class="bold">Métodos de Pago - Boleta Automática</span>
                    <div class="secondary-text">
                        Métodos de pago que emitirán boleta automáticamente.
                    </div>
                </div>

                <input-select class="ml5"
                inputClass="secondary"
                v-model="modalGeneral.paymentMethodAutoBoletaSelected"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddPaymentMethod($event, 'autoboleta_payment_methods')"
                :items="Util.Copy(paymentsMethods)"
                canType="search"
                v-tooltip="'Añadir método de pago'"
                icon="plus">
                </input-select>
            </div>
            <label class="mt15 mb20">
                <input type="checkbox" v-model="modalGeneral.transaction_methods_in_autoboleta"> 
                <div>
                    <div>Requiere que todos los métodos de pago de la transacción estén presentes en los métodos añadidos </div>
                    <div class="secondary-text">Si la transacción incluye un método de pago que no está configurado aquí, no se generará la boleta automáticamente</div>
                </div>
                <div class="checkmark"></div>
            </label>

            <div class="flex align-center well mb20" 
            v-for="(method, index) in modalGeneral.autoboleta_payment_methods" :key="`autoboleta-${index}`">
                <div class="bold flex-fill">{{dictMethods[method]? dictMethods[method] : method}}</div>
                <i class="options icon-trash" @click.stop="modalGeneral.autoboleta_payment_methods.splice(index, 1)"></i>
            </div>

            <div class="separator mt20 mb20"></div>

            <div class="flex align-center mb20">
                <div class="flex-fill">
                    <span class="bold">Integraciones - Boleta Automática</span>
                    <div class="secondary-text">
                        Integraciones cuyos pedidos emitirán boleta automáticamente.
                    </div>
                </div>

                <input-select class="ml5"
                inputClass="secondary"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddAutoboletaIntegration($event)"
                :items="autoboletaIntegrations"
                callbackOnly
                canType="search"
                v-tooltip="'Añadir integración'"
                icon="plus">
                </input-select>
            </div>

            <div class="secondary-text mb20">
                Esta selección aplica a pedidos recibidos directamente desde la integración, independientemente de los métodos de pago seleccionados para boleta automática.
            </div>

            <div class="secondary-text mb20" v-if="!modalGeneral.autoboleta_integrations.length">
                No hay integraciones configuradas para boleta automática.
            </div>

            <div class="flex align-center well mb20"
            v-for="(integration, index) in modalGeneral.autoboleta_integrations" :key="`autoboleta-integration-${integration}`">
                <div class="bold flex-fill">{{AutoboletaIntegrationName(integration)}}</div>
                <i class="options icon-trash" v-tooltip="'Quitar integración'" @click.stop="modalGeneral.autoboleta_integrations.splice(index, 1)"></i>
            </div>
        </div>
        <button slot="actions" class="primary purple" @click="Save()">Guardar</button>
    </modal>

    <modal v-model="modalSignature" dir="center" modalClass="sm" title="Ingresar Folios">
        <div class="section" v-if="modalSignature && modalSignature.folio">
            
            <div class="mb15">
                <div class="bold">Razón Social</div>
                <div>{{modalSignature.folio.sii_name}}</div>
            </div>

            <div class="mb15">
                <div class="bold">RUT</div>
                <div>{{modalSignature.folio.sii_rut}}</div>
            </div>

            <div class="mb15">
                <div class="bold">Tipo de Documento</div>
                <div>{{Util.DTE[modalSignature.folio.document_type]}}</div>
            </div>

            <div class="mb15">
                <div class="bold">Fecha Autorización</div>
                <div>{{modalSignature.folio.authorization_date}}</div>
            </div>

            <div class="">
                <div class="bold">Folios</div>
                <div>{{(modalSignature.folio.folio_finish - modalSignature.folio.folio_start)+1}}</div>
            </div>
            
        </div>
        <div v-else class="secondary-text pa20">Seleccione un archivo XML</div>
        
        <button-file accept=".xml" slot="actions"
        type="text"
        encoding="ISO-8859-1"
        @FileSelected="(text) => {ImportFolioBoleta(text)}">
            <button class="secondary">Seleccionar Archivo</button>
        </button-file>
        <button slot="actions" class="primary purple" @click="SaveFolio()">Ingresar Folios</button>
        
    </modal>

    <modal v-model="modalCert" dir="center" modalClass="sm" title="Certificado Digital">
        <div class="section" v-if="modalCert">
            <div class="secondary-text mb10">El certificado se usará para firmar los documentos electrónicos tributarios</div>
            <input-field
            v-model="modalCert.pass"
            label="Contraseña"
            placeholder="Contraseña del certificado"
            type="password">
            </input-field>
        </div>
        
        <button-file accept=".pfx, .p12" slot="actions" v-if="modalCert"
        :type="null"
        @FileSelected="(file) => {$set(modalCert, 'file', file)}">
            <button class="secondary">{{modalCert.file ? modalCert.file.name : 'Seleccionar Archivo'}}</button>
        </button-file>
        <button slot="actions" class="primary purple" @click="SaveCert()">Ingresar Certificado</button>
        
    </modal>

    <modal v-model="modalCertification" dir="up" desktopHeight="80vh" title="Ambiente de Certificación">
        <div class="section" v-if="modalCertification">
            <div class="secondary-text mb10">Se usarán los folios activo para timbrar.</div>
            <div class="input-style" v-for="(caso, index) in modalCertification.sets" :key="index">
                <div class="fill flex">
                    <div class="flex column flex-fill">
                        <div class="flex align-center">
                            <div class="flex-fill bold">Caso de Prueba {{index+1}}</div>
                            <i class="options icon-trash" @click="modalCertification.sets.splice(index, 1)" title="Eliminar Caso de Prueba"></i>
                            <i class="options icon-plus" @click="caso.items.push({item: '', quantity: 1, price: '', unit: '', exento: false})" title="Agregar Item a caso de prueba"></i>
                        </div>
                        <div>
                        <table class="table-certification" v-if="caso.items.length">
                            <tr>
                                <th>Item</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>Unidad</th>
                                <th style="text-align: center">Exento</th>
                                <th></th>
                            </tr>
                            <tr v-for="(item, indexItem) in caso.items" :key="`caso${index}item${indexItem}`">
                                <td><input v-model="item.item" type="text" placeholder="Nombre del item"></td>
                                <td><input v-model="item.quantity" type="number" style="border: none"></td>
                                <td><input v-model="item.price" type="number" placeholder="Unitario con IVA" style="border: none"></td>
                                <td><input v-model="item.unit" type="text" placeholder="Medida (Opcional)"></td>
                                <td class="ta-center"><input v-model="item.exento" type="checkbox"></td>
                                <td><i class="options icon-trash" @click="caso.items.splice(indexItem, 1)" title="Eliminar item"></i></td>
                            </tr>
                        </table>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-actions" v-if="modalCertification">
            <button-file accept=".txt"
            :type="'text'"
            @FileSelected="(text) => {LoadSet(text)}">
                <button class="fill">Cargar Set de Pruebas</button>
            </button-file>
            <button @click="modalCertification.sets.push({items: []})">Agregar caso de prueba</button>
            <button class="selected-color" @click="Confirm({
                title: `Se generarán los archivos de certificación y pero no serán enviados automáticamente al SII`,
                text: 'Generar',
                class: 'selected-color',
                function: () => {SendTest(false)}
            })">Generar</button>
            <button class="selected-color" @click="Confirm({
                title: `Se generarán los archivos de certificación y se enviarán automáticamente al SII`,
                text: 'Enviar',
                class: 'selected-color',
                function: () => {SendTest(true)}
            })">Enviar</button>
        </div>
    </modal>

    <modal v-model="modalCertificationFactura" :dir="['right', 'right']" :modalClass="['fill', 'lg right h100']" title="Ambiente de Certificación de Facturas">
        <tabs v-model="tabCertification" :tabs="tabsCertification" v-if="tabsCertification" :keyByTab="true"
        @OnTabPaso2="loadFieldsStep2()" @OnTabPaso3="$set(modalCertificationFactura, 'step3', {}) ">
            <div slot="Paso 1" class="pa20">
                <div v-if="modalCertificationFactura">
                    <div v-if="!modalCertificationFactura.zip">
                        <div class="secondary-text mb10">Se usarán los folios activo para timbrar.</div>

                        <div>
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generateSobre"> Generar Sobre <div class="checkmark"></div>
                            </label>    
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generateSobreDispatch"> Generar Sobre de Guías de Despacho <div class="checkmark"></div>
                            </label>
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generateSobreFacturaExenta"> Generar Sobre de Facturas Exentas <div class="checkmark"></div>
                            </label>    
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generateSaleBook"> Generar Libro de Venta <div class="checkmark"></div>
                            </label>    
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generatePurchaseBook"> Generar Libro de Compra <div class="checkmark"></div>
                            </label>
                            <label class="mb10">
                                <input type="checkbox" v-model="modalCertificationFactura.generateDispatchBook"> Generar Libro de Guías <div class="checkmark"></div>
                            </label>  
                        </div>

                        <div v-if="modalCertificationFactura.PeriodoTributarioVenta">
                            <div class="text-primary">Periodo Tributario Libro de Venta</div>
                            <div class="flex mb15">
                                <input-field class="mr15"
                                v-model="modalCertificationFactura.PeriodoTributarioVenta.year"
                                placeholder="1980"
                                label="Año">
                                </input-field>

                                <input-field class=""
                                v-model="modalCertificationFactura.PeriodoTributarioVenta.month"
                                placeholder="01"
                                label="Mes">
                                </input-field>
                            </div>
                        </div>

                        <div v-if="modalCertificationFactura.PeriodoTributarioCompra">
                            <div class="text-primary">Periodo Tributario Libro de Compra</div>
                            <div class="flex mb15">
                                <input-field class="mr15"
                                v-model="modalCertificationFactura.PeriodoTributarioCompra.year"
                                placeholder="2000"
                                label="Año">
                                </input-field>

                                <input-field class=""
                                v-model="modalCertificationFactura.PeriodoTributarioCompra.month"
                                placeholder="01"
                                label="Mes">
                                </input-field>
                            </div>
                        </div>

                        <div class="mb15" v-if="modalCertificationFactura.sets && modalCertificationFactura.sets.length">
                            <div class="text-primary mb15">Se ha cargado correctamente el archivo.</div>
                        </div>
                        <button-file slot="actions" accept=".txt" type="text" encoding="ISO-8859-1" @FileSelected="(text) => {LoadSetFactura(text)}">
                            <button class="primary">Cargar Set de Prueba</button>
                        </button-file>
                    </div>
                    <div v-else>
                        <div class="bold mb10">Descargue los archivos y proceda con el paso 2 para la certificación.</div>
                        <div class="text-primary mb5" v-if="modalCertificationFactura.track_sobre">Identificador de envío (sobre): {{modalCertificationFactura.track_sobre}}</div>
                        <div class="text-primary mb5" v-if="modalCertificationFactura.track_sobre_dispatch">Identificador de envío (sobre de guías de despacho): {{modalCertificationFactura.track_sobre_dispatch}}</div>
                        <div class="text-primary mb5" v-if="modalCertificationFactura.track_sobre_factura_exenta">Identificador de envío (sobre de factura exenta): {{modalCertificationFactura.track_sobre_factura_exenta}}</div>
                        <div class="text-primary mb5" v-if="modalCertificationFactura.track_libro_venta">Identificador de envío (libro de venta): {{modalCertificationFactura.track_libro_venta}}</div>
                        <div class="text-primary mb10" v-if="modalCertificationFactura.track_libro_compra">Identificador de envío (libro de compra): {{modalCertificationFactura.track_libro_compra}}</div>
                        <div class="text-primary mb10" v-if="modalCertificationFactura.track_libro_guias">Identificador de envío (libro de guías): {{modalCertificationFactura.track_libro_guias}}</div>
                        <button class="primary purple" @click="Util.DownloadZip('certificacion.zip', modalCertificationFactura.zip)">Descargar Archivos</button>
                    </div>
                </div>
            </div>
            <div slot="Paso 2" class="pa20">
                <div v-if="modalCertificationFactura && modalCertificationFactura.step2 && modalCertificationFactura.step2.fieldsReceiver && modalCertificationFactura.step2.zip">
                    <div class="bold mb10">Descargue los archivos y proceda con el paso 3 para la certificación.</div>
                    <div class="text-primary mb5">Identificador de envío (sobre): {{modalCertificationFactura.step2.track_id}}</div>
                    <button class="primary purple" @click="Util.DownloadZip('certificacion.zip', modalCertificationFactura.step2.zip)">Descargar Archivos</button>
                </div>
                <div v-if="modalCertificationFactura && modalCertificationFactura.step2 && modalCertificationFactura.step2.fieldsReceiver && !modalCertificationFactura.step2.zip">
                    <div class="text-primary mb15">En este paso se generarán los documentos para la simulación.</div>
                    <div class="secondary-text mb10">Se crearán 18 Facturas Eletrónicas, 1 Nota Crédito y 1 Nota débito.</div>
                    <div class="secondary-text mb10">Rellene los campos correspondientes al receptor del sobre.</div>
                    <div class="well mb20">
                        <div class="text-primary mb15">Receptor</div>

                        <input-field
                        inputClass="primary mb15 mr10"
                        v-model="modalCertificationFactura.step2.fieldsReceiver.rut"
                        placeholder="RUT"
                        label="RUT">
                        </input-field>

                        <input-field
                        inputClass="primary mb15 mr10"
                        v-model="modalCertificationFactura.step2.fieldsReceiver.razonSocial"
                        placeholder="Razón Social"
                        label="Razón Social">
                        </input-field>

                        <input-field
                        inputClass="primary mb15"
                        v-model="modalCertificationFactura.step2.fieldsReceiver.line_business"
                        placeholder="Giro"
                        label="Giro del receptor">
                        </input-field>
                        <input-field
                        inputClass="primary mb15 mr10"
                        v-model="modalCertificationFactura.step2.fieldsReceiver.address"
                        placeholder="Dirección"
                        label="Dirección">
                        </input-field>

                        <input-field
                        inputClass="primary mb15"
                        v-model="modalCertificationFactura.step2.fieldsReceiver.commune"
                        placeholder="Comuna"
                        label="Comuna">
                        </input-field>
                    </div>
                </div>
                <div v-if="modalCertificationFactura && modalCertificationFactura.step2 && modalCertificationFactura.step2.fieldsDetails && !modalCertificationFactura.step2.zip">
                    <div class="text-primary mb15">Detalles de facturas electrónicas</div>
                    <div class="secondary-text mb10">A continuación, complete los detalles de las facturas electrónicas.</div>
                    <div class="flex well mb20" v-for="(caso, index) in modalCertificationFactura.step2.fieldsDetails" :key="index">
                            <div class="fill flex">
                                <div class="flex column flex-fill">
                                    <div class="flex align-center">
                                        <div class="flex-fill bold">Caso {{index+1}}</div>
                                        <i class="options icon-plus" @click="caso.items.push({item: '', quantity: 0, price: 0, discount: 0, exento: false})" title="Agregar Item a caso de prueba"></i>
                                    </div>
                                    <div>
                                        <table class="table-certification-step2" v-if="caso.items.length">
                                            <tr>
                                                <th>Item</th>
                                                <th>Cantidad</th>
                                                <th>Precio</th>
                                                <th>Descuento</th>
                                                <th style="text-align: center">Exento</th>
                                                <th></th>
                                            </tr>
                                            <tr v-for="(item, indexItem) in caso.items" :key="`caso${index}item${indexItem}`">
                                                <td><input-field inputClass="primary" v-model="item.item" type="text" placeholder="Nombre del ítem"></input-field></td>
                                                <td><input-field inputClass="primary" v-model="item.quantity" type="number"></input-field></td>
                                                <td><input-field inputClass="primary" v-model="item.price" type="number" placeholder="Precio Unitario"></input-field></td>
                                                <td><input-field inputClass="primary" v-model="item.discount" type="number" placeholder="Descuento"></input-field></td>
                                                <td class="ta-center">
                                                    <label class="ml20">
                                                        <input type="checkbox" v-model="item.exento"><div class="checkmark"></div>
                                                    </label>
                                                </td>
                                                <td><i class="options icon-trash" @click="caso.items.splice(indexItem, 1)" title="Eliminar item"></i></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div slot="Paso 3" class="pa20">
                <div v-if="modalCertificationFactura && modalCertificationFactura.step3">
                    <div v-if="!modalCertificationFactura.step3.zip">
                        <div class="text-primary mb15">En este paso se generarán los documentos para el paso de intercambio.</div>
                        <div class="secondary-text mb10">Se crearán 3 xml (Recepción, Envío y Resultado).</div>
                        
                        <button-file accept=".xml" :type="null" slot="actions"
                        @FileSelected="$set(modalCertificationFactura.step3, 'file', $event)">
                            <button class="primary">{{modalCertificationFactura.step3.file? modalCertificationFactura.step3.file.name : 'Seleccionar archivo'}}</button>
                        </button-file>
                    </div>
                    <div v-else>
                        <div class="bold mb10">Descargue los archivos y proceda con el paso 4 para la certificación.</div>
                        <button class="primary purple" @click="Util.DownloadZip('certificacion_incercambio.zip', modalCertificationFactura.step3.zip)">Descargar Archivos</button>
                    </div>
                </div>
            </div>
        </tabs>

        <button v-if="tabCertification == 'Paso 1' && modalCertificationFactura && !modalCertificationFactura.zip" slot="actions" class="primary purple" @click="Confirm({
            title: `Se generarán los archivos de certificación y se enviarán automáticamente al SII`,
            text: 'Enviar',
            class: 'selected-color',
            function: () => {SendSetBasicoAfecto()}
        })">Enviar</button>

        <button v-if="tabCertification == 'Paso 2' && modalCertificationFactura && modalCertificationFactura.step2 && !modalCertificationFactura.step2.zip" slot="actions" class="primary purple" @click="Confirm({
            title: `Se generarán documentos correspondientes para la simulación y se enviarán automáticamente al SII`,
            text: 'Enviar',
            class: 'selected-color',
            function: () => {SendSimulation()}
        })">Enviar</button>

        <button v-if="tabCertification == 'Paso 3' && modalCertificationFactura && modalCertificationFactura.step3 && !modalCertificationFactura.step3.zip" slot="actions" class="primary purple" @click="Confirm({
            title: `Iniciar proceso de generar los xml para el proceso de intercambio`,
            text: 'Enviar',
            class: 'selected-color',
            function: () => {Exchange()}
        })">Enviar</button>
    </modal>

    <modal v-model="modalCertificationData" dir="up" desktopWidth="30vw" desktopHeight="50vh" title="Certificación">
        <div class="pa10 flex column" v-if="modalCertificationData">
            <div class="bold mb10" v-if="modalCertificationData.track_sobre">Se ha enviado la certificación correctamente</div>
            <div class="bold mb10" v-else>Se han generado los archivos de certificación correctamente</div>

            <div class="mb5" v-if="modalCertificationData.track_sobre"><span class="bold">Identificador de envío (sobre): </span>{{modalCertificationData.track_sobre}}</div>
            <div class="mb10" v-if="modalCertificationData.track_rvd"><span class="bold">Identificador de envío (RVD): </span>{{modalCertificationData.track_rvd}}</div>

            <button class="mb5" v-for="(boleta, index) in modalCertificationData.boletas" :key="index"
            @click="Util.PrintTransaction({custom_data: {boleta: boleta}}, 'BOLETA')">Imprimir Boleta {{boleta.folio}}</button>
            <!--<button @click="Util.DownloadFile({data: modalCertificationData.zip, type: 'text/plain'}, 'certificacion.zip', true)">Descargar Archivos</button>-->
            <button @click="Util.DownloadZip('certificacion.zip', modalCertificationData.zip)">Descargar Archivos</button>
        </div>
    </modal>

    <modal v-model="modalResendBoletas" title="Reenviar Boletas" :dir="['right', 'right']" :modalClass="['fill', 'lg right h100']">
        <div class="section" v-if="modalResendBoletas">
            <div class="hdvm mb20">
                <input-date v-model="modalResendBoletas.start" label="Inicio" format="HH:mm:ss DD/MM/YYYY"></input-date>
                <input-date v-model="modalResendBoletas.finish" label="Fin" format="HH:mm:ss DD/MM/YYYY"></input-date>
            </div>

            <div class="log-container mt20">
                <textarea v-if="modalResendBoletas.log" :value="modalResendBoletas.log" style="width: 100%" rows="20" readonly></textarea>
            </div>
            

        </div>
        <button v-if="modalResendBoletas" slot="actions" :class="modalResendBoletas.resend ? 'primary' : 'secondary'" @click="ResendBoletas()">{{modalResendBoletas.resend ? `Reenviar (${modalResendBoletas.count})` : 'Verificar'}}</button>
    </modal>

</div>
</template>

<script>
export default {
    data() {
        return {
            general: null,
            modalSignature: null,
            foliosBoleta: [],
            foliosFacturas: [],
            foliosNC: [],
            foliosND: [],
            foliosDG: [],
            foliosFacturasExenta: [],
            tabCertification: null,
            tabsCertification: [
                'Paso 1',
                'Paso 2',
                'Paso 3'
            ],
            dictMethods: {
                'CASH' : 'Efectivo',
                'BANK_DEPOSIT' : 'Transferencia',
                'ONLINE' : 'Pago Online',
            },
            sharedFoliosAvailable: false,
            modalCert: null,
            modalCertification: null,
            modalCertificationFactura: null,
            modalCertificationData: null,
            modalGeneral: null,
            actecos: [],
            paymentsMethods: [],
            autoboletaIntegrations: [ //TODO: @ramiro aqui se deberian cargar solo con los modulos activados
                {text: 'PedidosYa', value: 'PEDIDOSYA'},
                {text: 'Uber Eats', value: 'UBER_EATS'},
            ],
            regionalAddresses: [{"text":"ARICA","value":"ARICA","description":"ARICA, CAMARONES, PUTRE, GENERAL LAGOS"},{"text":"IQUIQUE","value":"IQUIQUE","description":"IQUIQUE, PICA, POZO ALMONTE, HUARA, CAMI\u00d1A, COLCHANE, ALTO HOSPICIO"},{"text":"ANTOFAGASTA","value":"ANTOFAGASTA","description":"ANTOFAGASTA, MEJILLONES, SIERRA GORDA"},{"text":"CALAMA","value":"CALAMA","description":"CALAMA, SAN PEDRO DE ATACAMA, OLLAGUE"},{"text":"TOCOPILLA","value":"TOCOPILLA","description":"TOCOPILLA, MAR\u00cdA ELENA"},{"text":"TALTAL","value":"TALTAL","description":"TALTAL"},{"text":"COPIAP\u00d3","value":"COPIAP\u00d3","description":"COPIAP\u00d3, CALDERA, TIERRA AMARILLA"},{"text":"CHA\u00d1ARAL","value":"CHA\u00d1ARAL","description":"CHA\u00d1ARAL, DIEGO DE ALMAGRO"},{"text":"VALLENAR","value":"VALLENAR","description":"VALLENAR, FREIRINA, HUASCO, ALTO DEL CARMEN"},{"text":"LA SERENA","value":"LA SERENA","description":"LA SERENA, LA HIGUERA, PAIHUANO, ANDACOLLO, VICU\u00d1A"},{"text":"OVALLE","value":"OVALLE","description":"OVALLE, MONTE PATRIA, PUNITAQUI, COMBARBAL\u00c1, R\u00cdO HURTADO"},{"text":"ILLAPEL","value":"ILLAPEL","description":"ILLAPEL, SALAMANCA, LOS VILOS, CANELA"},{"text":"COQUIMBO","value":"COQUIMBO","description":"COMQUIMBO"},{"text":"VALPARA\u00cdSO","value":"VALPARA\u00cdSO","description":"VALPARA\u00cdSO, CASABLANCA, JUAN FERN\u00c1NDEZ, ISLA DE PASCUA"},{"text":"VI\u00d1A DEL MAR","value":"VI\u00d1A DEL MAR","description":"CONC\u00d3N, QUINTERO, PUCHUNCAV\u00cd, VI\u00d1A DEL MAR"},{"text":"LA LIGUA","value":"LA LIGUA","description":"LA LIGUA, PETORCA, CABILDO, ZAPALLAR, PAPUDO"},{"text":"SAN ANTONIO","value":"SAN ANTONIO","description":"SAN ANTONIO, SANTO DOMINGO, CARTAGENA, EL TABO, EL QUISCO, ALGARROBO"},{"text":"QUILLOTA","value":"QUILLOTA","description":"QUILLOTA, NOGALES, HIJUELAS, LA CALERA, LA CRUZ, LIMACHE, OLMU\u00c9"},{"text":"SAN FELIPE","value":"SAN FELIPE","description":"SAN FELIPE, PANQUEHUE, CATEMU, PUTAENDO, SANTA MAR\u00cdA, LLAY LLAY"},{"text":"LOS ANDES","value":"LOS ANDES","description":"LOS ANDES, CALLE LARGA, SAN ESTEBAN, RINCONADA"},{"text":"VILLA ALEMANA","value":"VILLA ALEMANA","description":"VILLA ALEMANA, QUILPU\u00c9"},{"text":"RANCAGUA","value":"RANCAGUA","description":"RANCAGUA, MACHAL\u00cd, GRANEROS, SAN FRANCISCO DE MOSTAZAL, DO\u00d1IHUE, CODEGUA, RENGO, COLTAUCO, REQUINOA, OLIVAR, MALLOA, COINCO, QUINTA DE TILCOCO"},{"text":"SAN FERNANDO","value":"SAN FERNANDO","description":"SAN FERNANDO, CHIMBARONGO, NANCAGUA, PLACILLA"},{"text":"SANTA CRUZ","value":"SANTA CRUZ","description":"SANTA CRUZ, LOLOL, PALMILLA, PERALILLO, CH\u00c9PICA, PUMANQUE"},{"text":"SAN VICENTE TAGUA TAGUA","value":"SAN VICENTE TAGUA TAGUA","description":"SAN VICENTE, LAS CABRAS, PEUMO, PICHIDEGUA"},{"text":"PICHILEMU","value":"PICHILEMU","description":"PICHILEMU, PAREDONES, MARCHIGUE, LITUECHE, LA ESTRELLA"},{"text":"TALCA","value":"TALCA","description":"TALCA, SAN CLEMENTE, PELARCO, R\u00cdO CLARO, PENCAHUE, MAULE, CUREPTO, SAN JAVIER"},{"text":"LINARES","value":"LINARES","description":"LINARES, YERBAS BUENAS, COLB\u00daN, LONGAV\u00cd, VILLA ALEGRE"},{"text":"CONSTITUCI\u00d3N","value":"CONSTITUCI\u00d3N","description":"CONSTITUCI\u00d3N, EMPEDRADO"},{"text":"CAUQUENES","value":"CAUQUENES","description":"CAUQUENES, PELLUHUE, CHANCO"},{"text":"PARRAL","value":"PARRAL","description":"PARRAL, RETIRO"},{"text":"CURIC\u00d3","value":"CURIC\u00d3","description":"CURIC\u00d3, TENO, ROMERAL, MOLINA, HUALA\u00d1E, SAGRADA FAMILIA, LICANT\u00c9N, VICHUQU\u00c9N, RAUCO"},{"text":"CONCEPCI\u00d3N","value":"CONCEPCI\u00d3N","description":"CONCEPCI\u00d3N, CHIGUAYANTE, SAN PEDRO DE LA PAZ, PENCO, HUALQUI, FLORIDA, TOM\u00c9, CORONEL, LOTA, SANTA JUANA, ARAUCO"},{"text":"CHILL\u00c1N","value":"CHILL\u00c1N","description":"CHILL\u00c1N, PINTO, EL CARMEN, SAN IGNACIO, PEMUCO, YUNGAY, BULNES, QUILL\u00d3N, RANQUIL, PORTEZUELO, COELEMU, TREHUACO, QUIRIHUE, COBQUECURA, NINHUE, CHILL\u00c1N VIEJO"},{"text":"LOS \u00c1NGELES","value":"LOS \u00c1NGELES","description":"LOS \u00c1NGELES, SANTA BARBARA, LAJA, QUILLECO, NACIMIENTO, NEGRETE, MULCH\u00c9N, QUILACO, YUMBEL, CABRERO, SAN ROSENDO, TUCAPEL, ANTUCO, ALTO B\u00cdO-B\u00cdO"},{"text":"SAN CARLOS","value":"SAN CARLOS","description":"SAN CARLOS, SAN GREGORIO DE \u00d1INQUEN, SAN NICOL\u00c1S, SAN FABI\u00c1N DE ALICO"},{"text":"TALCAHUANO","value":"TALCAHUANO","description":"TALCAHUANO, HUALP\u00c9N"},{"text":"LEBU","value":"LEBU","description":"LEBU, CURANILAHUE, LOS ALAMOS, CA\u00d1ETE, CONTULMO, TIR\u00daA"},{"text":"TEMUCO","value":"TEMUCO","description":"TEMUCO, VILC\u00daN, FREIRE, CUNCO, LAUTARO, PERQUENCO, GALVARINO, NUEVA IMPERIAL, CARAHUE, PUERTO SAAVEDRA, PITRUFQU\u00c9N, GORBEA, TOLT\u00c9N, LONCOCHE, MELIPEUCO, TEODORO SCHMIDT, PADRE LAS CASAS, CHOLCHOL"},{"text":"ANGOL","value":"ANGOL","description":"ANGOL, PUR\u00c9N, LOS SAUCES, REINACO, COLLIPULLI, ERCILLA"},{"text":"VICTORIA","value":"VICTORIA","description":"VICTORIA, TRAIGU\u00c9N, LUMACO, CURACAUT\u00cdN, LONQUIMAY"},{"text":"VILLARRICA","value":"VILLARRICA","description":"VILLARRICA, PUC\u00d3N, CURARREHUE"},{"text":"VALDIVIA","value":"VALDIVIA","description":"VALDIVIA, MARIQUINA, M\u00c1FIL, CORRAL, LOS LAGOS, PAILLACO, FUTRONO"},{"text":"LANCO","value":"LANCO","description":"LANCO"},{"text":"PANGUIPULLI","value":"PANGUIPULLI","description":"PANGUIPULLI"},{"text":"LA UNI\u00d3N","value":"LA UNI\u00d3N","description":"LA UNI\u00d3N, R\u00cdO BUENO, LAGO RANCO"},{"text":"PUERTO MONTT","value":"PUERTO MONTT","description":"PUERTO MONTT, CALBUCO, MAULL\u00cdN, LOS MUERMOS, HUALAIHU\u00c9"},{"text":"PUERTO VARAS","value":"PUERTO VARAS","description":"PUERTO VARAS, COCHAM\u00d3, FRESIA, LLANQUIHUE, FRUTILLAR"},{"text":"ANCUD","value":"ANCUD","description":"ANCUD, QUEMCHI"},{"text":"OSORNO","value":"OSORNO","description":"OSORNO, PUYEHUE, PURRANQUE, R\u00cdO NEGRO, SAN PABLO, SAN JUAN DE LA COSTA, PUERTO OCTAY"},{"text":"CASTRO","value":"CASTRO","description":"CASTRO, CURACO DE V\u00c9LEZ, CHOCHI, DALCAHUE, PUQUELD\u00d3N, QUEIL\u00c9N, QUELL\u00d3N"},{"text":"CHAIT\u00c9N","value":"CHAIT\u00c9N","description":"CHAIT\u00c9N, PALENA, FUTALEUF\u00da"},{"text":"COYHAIQUE","value":"COYHAIQUE","description":"COYHAIQUE, R\u00cdO IBA\u00d1EZ"},{"text":"COCHRANE","value":"COCHRANE","description":"O`HIGGINS, TORTEL, COCHRANE, GUADAL, PUERTO BELTRAND"},{"text":"AYS\u00c9N","value":"AYS\u00c9N","description":"AYS\u00c9N, CISNES, LAGO VERDE, GUAITECAS"},{"text":"CHILE CHICO","value":"CHILE CHICO","description":"CHILE CHICO"},{"text":"PUNTA ARENAS","value":"PUNTA ARENAS","description":"PUNTA ARENAS, R\u00cdO VERDE, SAN GREGORIO, LAGUNA BLANCA, CABO DE HORNOS"},{"text":"PUERTO NATALES","value":"PUERTO NATALES","description":"PUERTO NATALES, TORRES DEL PAINE"},{"text":"PORVENIR","value":"PORVENIR","description":"PORVENIR, PRIMAVERA, TIMAUKEL"},{"text":"SANTIAGO NORTE","value":"SANTIAGO NORTE","description":"INDEPENDENCIA, RECOLETA, HUECHURABA, CONCHAL\u00cd, QUILICURA, COLINA, LAMPA, TILTIL"},{"text":"SANTIAGO CENTRO","value":"SANTIAGO CENTRO","description":"SANTIAGO"},{"text":"SANTIAGO PONIENTE","value":"SANTIAGO PONIENTE","description":"CERRO NAVIA, CURACAV\u00cd, ESTACI\u00d3N CENTRAL, LO PRADO, PUDAHUEL, QUINTA NORMAL, RENCA"},{"text":"MELIPILLA","value":"MELIPILLA","description":"MELIPILLA, SAN PEDRO, ALHU\u00c9, MAR\u00cdA PINTO"},{"text":"MAIP\u00da","value":"MAIP\u00da","description":"MAIP\u00da, CERRILLOS, PADRE HURTADO, PE\u00d1AFLOR, TALAGANTE, EL MONTE, ISLA DE MAIPO"},{"text":"SANTIAGO ORIENTE","value":"SANTIAGO ORIENTE","description":"LAS CONDES, VITACURA, LO BARNECHEA"},{"text":"\u00d1U\u00d1OA","value":"\u00d1U\u00d1OA","description":"\u00d1U\u00d1OA, LA REINA, MACUL, PE\u00d1ALOL\u00c9N"},{"text":"PROVIDENCIA","value":"PROVIDENCIA","description":"PROVIDENCIA"},{"text":"SANTIAGO SUR","value":"SANTIAGO SUR","description":"SAN MIGUEL, LA CISTERNA, SAN JOAQU\u00cdN, PEDRO AGUIRRE CERDA, LO ESPEJO, LA GRANJA, LA PINTANA, SAN RAM\u00d3N"},{"text":"LA FLORIDA","value":"LA FLORIDA","description":"LA FLORIDA, PUENTE ALTO, PIRQUE, SAN JOS\u00c9 DE MAIPO"},{"text":"SAN BERNARDO","value":"SAN BERNARDO","description":"SAN BERNARDO, CALERA DE TANGO, EL BOSQUE"},{"text":"BUIN","value":"BUIN","description":"BUIN, PAINE"}],
            franchise: null,
            modalResendBoletas: null,
        }
    },
    mounted()
    {
        
    },
    methods: {
        Init(force)
        {
            if(force || !this.general)
            {
                this.Loading();
                axios.get(`/sii/${this.Local.id}/general`).then( ({data}) => {
                    this.general = data.settings;
                    this.foliosBoleta = data.folios_boleta;
                    this.foliosFacturas = data.folios_factura;
                    this.foliosNC = data.folios_nc;
                    this.foliosND = data.folios_nd;
                    this.foliosDG = data.folios_dg;
                    this.foliosFacturasExenta = data.folios_factura_exenta;
                    this.sharedFoliosAvailable = data.shared_folios_available;
                    this.franchise = data.franchise;
                    this.Response(data);
                }).catch(err => {
                    this.Response(err);
                });
            }
        },
        async OpenGeneral()
        {
            this.Loading();
            try {
                let actecos = (await axios.get(`/sii/actecos`)).data;     
                actecos.forEach( acteco => {
                this.actecos.push(
                        {text: acteco, value: acteco }
                    );
                });

                let methods = (await axios.get(`/methods/${this.Local.id}?v2=true`)).data;
                this.paymentsMethods = this.Util.PaymentMethodsToOptions(methods);
                
                this.modalGeneral = this.Util.Copy(this.general);
                this.Response([]);

            } catch (error) {
                this.Response(error)   
            }
        },
        AddAutoboletaIntegration(integration)
        {
            if(!this.autoboletaIntegrations.some(item => item.value === integration)) return;
            if(this.modalGeneral.autoboleta_integrations.includes(integration)) return;
            this.modalGeneral.autoboleta_integrations.push(integration);
        },
        AutoboletaIntegrationName(integration)
        {
            const item = this.autoboletaIntegrations.find(item => item.value === integration);
            return item ? item.text : integration;
        },
        Save()
        {
            this.Loading();
            if(this.modalGeneral.sii_branch_office) this.$set(this.modalGeneral, 'sii_branch_office', this.modalGeneral.sii_branch_office.toUpperCase());
            axios.post(`/sii/${this.Local.id}/general`, this.modalGeneral).then(res => {
                this.Info('Datos guardados correctamente');
                this.general = this.modalGeneral;
                this.modalGeneral = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        ImportFolioBoleta(text)
        {
            var domParser = new DOMParser();
            var xmlDocument = domParser.parseFromString(text, "text/xml");
            
            var data = {
                text: text,
                sii_rut: xmlDocument.getElementsByTagName('RE')[0].childNodes[0].nodeValue,
                sii_name: xmlDocument.getElementsByTagName('RS')[0].childNodes[0].nodeValue,
                document_type: xmlDocument.getElementsByTagName('TD')[0].childNodes[0].nodeValue,
                folio_start: xmlDocument.getElementsByTagName('D')[0].childNodes[0].nodeValue,
                folio_finish: xmlDocument.getElementsByTagName('H')[0].childNodes[0].nodeValue,
                authorization_date: xmlDocument.getElementsByTagName('FA')[0].childNodes[0].nodeValue,
                digital_signature: xmlDocument.getElementsByTagName('FRMA')[0].childNodes[0].nodeValue,
            }
            // console.log(data);
            this.$set(this.modalSignature, 'folio', data);
        },
        SaveFolio()
        {
            if(!this.modalSignature.folio) return this.Info('Ingrese un archivo de folios');
            let typeDocuments = [33, 36, 56, 61];
            if(typeDocuments.indexOf(this.modalSignature.folio.document_type) !== -1) return this.Info('Tipo de documento inválido');

            this.Loading();
            axios.put(`/sii/${this.Local.id}/folio`, this.modalSignature.folio).then( ({data}) => {
                this.modalSignature = null;

                const config = {
                    39: {
                        list: this.foliosBoleta,
                        message: 'Folios de boleta ingresados',
                        activeKey: 'id_active_folio',
                    },
                    33: {
                        list: this.foliosFacturas,
                        message: 'Folios de factura electrónica ingresados',
                        activeKey: 'id_active_folio_factura',
                    },
                    61: {
                        list: this.foliosNC,
                        message: 'Folios de Nota de Crédito Electrónica ingresados',
                        activeKey: 'id_active_folio_nc',
                    },
                    56: {
                        list: this.foliosND,
                        message: 'Folios de Nota de Débito Electrónica ingresados',
                        activeKey: 'id_active_folio_nd',
                    },
                    52: {
                        list: this.foliosDG,
                        message: 'Folios de Guías de Despacho ingresados',
                        activeKey: 'id_active_folio_dg',
                    },
                    34: {
                        list: this.foliosFacturasExenta,
                        message: 'Folios de factura electrónica exenta ingresados',
                        activeKey: 'id_active_folio_factura_exenta',
                    },
                };

                const documentType = data.folio.document_type;
                const current = config[documentType];

                if (!current) return;

                current.list.unshift(data.folio);
                this.Info(current.message);

                this.$set(
                    this.general,
                    current.activeKey,
                    data[current.activeKey]
                );
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteFolios(id, type)
        {
            this.Loading();
            axios.delete(`/sii/${this.Local.id}/folio/${id}`).then( ({data}) => {
                const config = {
                    39: {
                        list: this.foliosBoleta,
                        activeKey: 'id_active_folio',
                        message: 'Folios de boletas eliminados',
                    },
                    33: {
                        list: this.foliosFacturas,
                        activeKey: 'id_active_folio_factura',
                        message: 'Folios de Facturas Electrónicas eliminados',
                    },
                    56: {
                        list: this.foliosND,
                        activeKey: 'id_active_folio_nd',
                        message: 'Folios de Nota de Débito Electrónica eliminados',
                    },
                    52: {
                        list: this.foliosDG,
                        activeKey: 'id_active_folio_dg',
                        message: 'Folios de Guías de Despacho eliminados',
                    },
                    61: {
                        list: this.foliosNC,
                        activeKey: 'id_active_folio_nc',
                        message: 'Folios de Nota de Crédito Electrónica eliminados',
                    },
                    34: {
                        list: this.foliosFacturasExenta,
                        activeKey: 'id_active_folio_factura_exenta',
                        message: 'Folios de Facturas Electrónicas exentas eliminados',
                    },
                };

                const current = config[type];

                if (!current)  return;

                const index = current.list.findIndex(folio => folio.id == id);

                if (index !== -1) current.list.splice(index, 1);

                this.$set(
                    this.general,
                    current.activeKey,
                    data[current.activeKey]
                );

                this.Info(current.message);
            }).catch(err => {
                this.Response(err);
            });
        },
        SetActiveFolios(id, type)
        {
            this.Loading();
            axios.patch(`/sii/${this.Local.id}/folio/active/${id}`).then(res => {
                console.log(res.data.message);
                this.Info(res.data.message);
                const typeToPropertyMap = {
                    61: 'id_active_folio_nc',
                    33: 'id_active_folio_factura',
                    56: 'id_active_folio_nd',
                    52: 'id_active_folio_dg',
                    34: 'id_active_folio_factura_exenta',
                };
                const defaultProperty = 'id_active_folio';

                const dtePropertyName = typeToPropertyMap[type] || defaultProperty;

                this.$set(this.general, dtePropertyName, res.data[dtePropertyName]);
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveCert()
        {
            if(!this.modalCert.file) return this.Info(`Seleccione un archivo de certificado digital`);
            if(!this.modalCert.pass) return this.Info(`Ingrese la contraseña del certificado`);

            var formData = new FormData();
            formData.append('file', this.modalCert.file);
            formData.append('pass', this.modalCert.pass);

            this.Loading();
            axios.post(`/sii/${this.Local.id}/cert`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                this.Info('Certificado guardado');
                this.$set(this.general, 'cert_at', res.data);
                this.modalCert = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        /*
        Carga un set de pruebas
        */
        LoadSet(text)
        {
            text = text.replace(/\t+/g, '|').replace(/Item\|Cantidad\|Precio Unitario con IVA/g, '').replace();
            var parts = text.split(/=========/g);
            var sets = [];
            parts.forEach(txt => {
                var lines = txt.split(/\n/g);
                var set = [];
                lines.forEach(line => {
                    if(line.indexOf('|') > -1)
                    {
                        var cols = line.trim().split(/\|/);
                        set.push({item: cols[0], quantity: cols[1], price: cols[2], unit: '', exento: false});
                    }
                });
                if(set.length)
                {
                    sets.push({items: set});
                }
            });
            this.$set(this.modalCertification, 'sets', sets);
        },
        /**
         * Carga un set de pruebas para la certificación de factura
         */
        LoadSetFactura(text){
            text = text.replace(/\t+/g, '|').replace(/Item\|Cantidad\|Precio Unitario con IVA/g, '');
            let parts = text.split(/=========/g);
            let sets = [];
            let outForeachSet = false;
            
            // Procesar SET LIBRO DE COMPRAS
            let partsShopping = ((text.split('SET LIBRO DE COMPRAS'))[1]).split(/=========/g);
            
            // Procesar SET GUIA DE DESPACHO
            let partsDispatch = [];
            if(text.indexOf('SET GUIA DE DESPACHO') > -1){
                let dispatchSection = text.split('SET GUIA DE DESPACHO')[1];
                if(dispatchSection.indexOf('SET LIBRO DE GUIAS') > -1){
                    dispatchSection = dispatchSection.split('SET LIBRO DE GUIAS')[0];
                }
                // partsDispatch = dispatchSection.split(/={14,}/g);
                const regexCasos = /CASO\s+\d+-\d+[\s\S]*?(?=CASO\s+\d+-\d+|$)/g;
                partsDispatch = dispatchSection.match(regexCasos) || [];
            }
            
            // Procesar SET LIBRO DE GUIAS
            let dispatchBookText = '';
            if(text.indexOf('SET LIBRO DE GUIAS') > -1){
                dispatchBookText = text.split('SET LIBRO DE GUIAS')[1];
            }
            
            // Procesamiento original de facturas
            parts.forEach((txt) => {
                let lines = txt.split(/\n/g);
                let set = [];
                let global_discount = null;
                let type_document = null;
                let casoSet = null;
                
                if(txt.indexOf('DOCUMENTO|FACTURA ELECTRONICA') > -1) type_document = 33;
                if(txt.indexOf('DOCUMENTO|NOTA DE DEBITO ELECTRONICA') > -1) type_document = 56;
                if(txt.indexOf('DOCUMENTO|NOTA DE CREDITO ELECTRONICA') > -1) type_document = 61;
                
                lines.forEach((line, index) => {
                    if(line.indexOf('SET LIBRO DE VENTAS') > -1) return outForeachSet = true;
                    if(line.indexOf('|') > -1){
                        let cols = line.trim().split(/\|/);
                        if(!isNaN(parseInt(cols[1]))){
                            if(cols[1].indexOf('%') > -1){
                                global_discount = parseFloat(cols[1])+'%';
                            }else{
                                if(txt.indexOf('CASO') > -1){
                                    let txtPieces = txt.split(/\n/g);
                                        if(index != 4 && index != 6){
                                            const casoLine = txtPieces
                                                .slice()
                                                .reverse()
                                                .find(line => line.indexOf('CASO') > -1 && line.indexOf('-') > -1);
                                            
                                            if(casoLine){
                                                let caso = casoLine.split('CASO')[1].split('-');
                                                casoSet = `CASO ${parseInt(caso[0])}-${parseInt(caso[1]-1)}`;
                                            }
                                        }
                                }
                                set.push({
                                    item: cols[0], 
                                    quantity: parseInt(cols[1]), 
                                    price: parseInt(cols[2]), 
                                    discount: parseInt(cols[3]), 
                                    exento: cols[0].indexOf('EXENTO') > -1
                                });
                            }
                        }
                    }
                });
                
                if(outForeachSet) return;
                if(set.length) sets.push({items: set, global_discount, type_document, reference: casoSet || null});
            });

            // Procesamiento del SET LIBRO DE COMPRAS (original)
            let setShopping = [];
            partsShopping.forEach(txt => {
                if(txt != ''){
                    let lines = txt.split(/\n/g);
                    if(lines.length > 10){
                        lines.forEach((line, indexLine) => {
                            let type_document = null;
                            if(line.indexOf('|') > -1){
                                let cols = line.trim().split(/\|/);
                                if(lines[indexLine+2]){
                                    let calculateIndexLine = (indexLine/2).toString().split('.')[0] % 2;
                                    if(!calculateIndexLine){
                                        let NewCols = cols.concat(lines[indexLine+2].trim().split(/\|/));
                                        if(NewCols[0].trim() == 'FACTURA') type_document = 30;
                                        if(NewCols[0].trim() == 'FACTURA ELECTRONICA') type_document = 33;
                                        if(NewCols[0].trim() == 'NOTA DE CREDITO') type_document = 60;
                                        if(NewCols[0].trim() == 'FACTURA DE COMPRA ELECTRONICA') type_document = 46;
                                        
                                        setShopping.push({
                                            document: NewCols[0].trim(), 
                                            folio: parseInt(NewCols[1]), 
                                            exempt: parseInt(NewCols[2]), 
                                            afecto: parseInt(NewCols[3]), 
                                            type_document 
                                        });
                                    }
                                }
                            }
                        });
                    }
                }
            });

            // Procesamiento del SET GUIA DE DESPACHO
            let setDispatch = [];
            partsDispatch.forEach((txt) => {
                if(txt.trim() != ''){
                    let lines = txt.split(/\n/g);
                    let dispatch = {
                        caso: null,
                        motivo: null,
                        traslado_por: null,
                        items: []
                    };
                    
                    lines.forEach((line, index) => {
                        // Extraer número de caso
                        if(line.indexOf('CASO') > -1 && line.indexOf('-') > -1){
                            dispatch.caso = line.split('CASO')[1].trim();
                        }
                        
                        // Extraer motivo
                        if(line.indexOf('MOTIVO:') > -1){
                            dispatch.motivo = line.split('MOTIVO:')[1].trim();
                        }
                        
                        // Extraer traslado por
                        if(line.indexOf('TRASLADO POR:') > -1){
                            dispatch.traslado_por = line.split('TRASLADO POR:')[1].trim();
                        }
                        
                        // Extraer items
                        if(line.indexOf('|') > -1){
                            let cols = line.trim().split(/\|/);
                            if(cols[0].indexOf('ITEM') > -1 && !isNaN(parseInt(cols[1]))){
                                dispatch.items.push({
                                    item: cols[0].trim(),
                                    quantity: parseInt(cols[1]),
                                    price: cols[2] ? parseInt(cols[2]) : null
                                });
                            }
                        }
                    });
                    
                    if(dispatch.caso){
                        setDispatch.push(dispatch);
                    }
                }
            });

            // Procesamiento del SET LIBRO DE GUIAS
            let dispatchBook = {
                observations: []
            };
            
            if(dispatchBookText){
                let lines = dispatchBookText.split(/\n/g);
                lines.forEach((line) => {
                    if(line.indexOf('CASO') > -1 && line.indexOf('CORRESPONDE') > -1){
                        dispatchBook.observations.push(line.trim());
                    }
                });
            }

            let partsExenta = [];
            if(text.indexOf('SET FACTURA EXENTA') > -1){
                let exentaSection = text.split('SET FACTURA EXENTA')[1];
                exentaSection = exentaSection.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                
                const rawBlocks = exentaSection.split(/={2,}/g);
                
                partsExenta = rawBlocks.reduce((acc, block, i) => {
                    const prevBlock = rawBlocks[i - 1];
                    if(prevBlock && /CASO\s+\d+-\d+\s*$/.test(prevBlock.trim())){
                        const casoLine = prevBlock.trim().split('\n').pop();
                        acc.push(casoLine + '\n' + block);
                    }
                    return acc;
                }, []);
            }

            let setExenta = [];
            partsExenta.forEach((txt) => {
                txt = txt.replace(/\t+/g, '|').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                if(txt.trim() === '') return;

                let lines = txt.split(/\n/g);
                let set = [];
                let type_document = null;
                let casoSet = null;
                let reference = null;
                let global_discount = null;

                if(txt.indexOf('DOCUMENTO|FACTURA NO AFECTA O EXENTA ELECTRONICA') > -1) type_document = 34;
                if(txt.indexOf('DOCUMENTO|NOTA DE CREDITO ELECTRONICA') > -1)            type_document = 61;
                if(txt.indexOf('DOCUMENTO|NOTA DE DEBITO ELECTRONICA') > -1)             type_document = 56;

                const casoLine = lines.find(l => /^CASO\s+\d+-\d+/.test(l.trim()));
                if(casoLine){
                    const casoMatch = casoLine.match(/CASO\s+(\d+)-(\d+)/);
                    if(casoMatch) casoSet = `CASO ${casoMatch[1]}-${casoMatch[2]}`;
                }

                const refLine = lines.find(l => l.startsWith('REFERENCIA|'));
                const razonLine = lines.find(l => l.startsWith('RAZON REFERENCIA|'));
                if(refLine){
                    const refContent = refLine.split('REFERENCIA|')[1] || '';
                    const refMatch = refContent.match(/CASO\s+(\d+)-(\d+)/);
                    
                    let refDocument = null;
                    if(refContent.indexOf('FACTURA NO AFECTA O EXENTA ELECTRONICA') > -1) refDocument = 34;
                    else if(refContent.indexOf('NOTA DE CREDITO ELECTRONICA') > -1)        refDocument = 61;
                    else if(refContent.indexOf('NOTA DE DEBITO ELECTRONICA') > -1)         refDocument = 56;
                    else if(refContent.indexOf('FACTURA ELECTRONICA') > -1)                refDocument = 33;

                    reference = {
                        caso:     refMatch ? `CASO ${refMatch[1]}-${refMatch[2]}` : null,
                        document: refDocument,
                        motivo:   razonLine ? razonLine.split('RAZON REFERENCIA|')[1].trim() : null
                    };
                }

                const headerLine = lines.find(l => /^ITEM\|/.test(l.trim()));
                let hasUnidadMedida = false;
                let hasQuantity = false;
                if(headerLine){
                    hasUnidadMedida = headerLine.indexOf('UNIDAD MEDIDA') > -1;
                    hasQuantity     = headerLine.indexOf('CANTIDAD') > -1;
                }

                lines.forEach((line) => {
                    if(line.indexOf('|') === -1) return;

                    let cols = line.trim().split(/\|/);
                    const col0 = cols[0] ? cols[0].trim() : '';
                    const col1 = cols[1] ? cols[1].trim() : '';
                    const col2 = cols[2] ? cols[2].trim() : '';
                    const col3 = cols[3] ? cols[3].trim() : '';

                    if(['ITEM','DOCUMENTO','REFERENCIA','RAZON REFERENCIA'].some(h => col0.startsWith(h))) return;
                    if(col0 === '') return;

                    // Descuento global
                    if(col1.indexOf('%') > -1){
                        global_discount = col1;
                        return;
                    }

                    let quantity = null;
                    let price    = null;
                    let discount = null;

                    if(hasQuantity){
                        quantity = parseInt(col1) || null;
                        if(hasUnidadMedida){
                            price = parseInt(col3) || null;
                        } else {
                            price = parseInt(col2) || null;
                            discount = !isNaN(parseInt(col3)) ? parseInt(col3) : null;
                        }
                    } else {
                        quantity = null;
                        price = parseInt(col1) || null;
                    }

                    set.push({ item: col0, quantity, price, discount, exento: true });
                });

                setExenta.push({
                    caso:            casoSet,
                    items:           set,
                    global_discount,
                    type_document,
                    reference:       reference || null
                });
            });

            // Asignar resultados
            let setsShoppingBook = {
                documents: setShopping,
                caseNumber: null
            };

            this.$set(this.modalCertificationFactura, 'shoppingBook', setsShoppingBook);
            this.$set(this.modalCertificationFactura, 'sets', sets);
            this.$set(this.modalCertificationFactura, 'dispatchGuides', setDispatch.length > 0 ? setDispatch : null);
            this.$set(this.modalCertificationFactura, 'dispatchBook', dispatchBook.observations.length > 0 ? dispatchBook : null);
            this.$set(this.modalCertificationFactura, 'exentaSet', setExenta.length > 0 ? setExenta : null);
        },
        /*
        Envia un set de pruebas para certificacion
        */
        SendTest(autoUpload)
        {
            this.modalCertification.auto_upload = autoUpload;

            this.Loading();
            axios.post(`/sii/${this.Local.id}/certification`, this.modalCertification).then(res => {
                console.log(res.data);
                this.Response(res);
                this.modalCertificationData = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        SendSetBasicoAfecto(){
            const reqParam = this.modalCertificationFactura;
            if(!reqParam.shoppingBook) return this.Info('Se debe cargar el Set de prueba');
            
            if(
                !reqParam.generateSobre && 
                !reqParam.generateSaleBook && 
                !reqParam.generatePurchaseBook && 
                !reqParam.generateDispatchBook && 
                !reqParam.generateSobreDispatch &&
                !reqParam.generateSobreFacturaExenta
            ) return this.Info('Se debe realizar al menos una acción');

            this.Loading();
            axios.post(`/sii/${this.Local.id}/setbasico`, reqParam).then( ({data}) => {
                if(!data.error) this.modalCertificationFactura = data;
                this.Info(data.message);
            }).catch(err => {
                this.Response(err);
                if(err.response.data.message) this.Info(err.response.data.message);
            });
        },
        SendSimulation(){
            let step2 = this.modalCertificationFactura.step2;

            let receiver = step2.fieldsReceiver;

            //Sí receptor tiene al menos un campo, debe tenerlos todos
            if(Object.keys(receiver).length > 0){
                if(!receiver.rut) return this.Info('Ingrese el RUT del receptor');
                if(!receiver.razonSocial) return this.Info('Ingrese la razón social del receptor');
                if(!receiver.line_business) return this.Info('Ingrese el giro del receptor');
                if(!receiver.address) return this.Info('Ingrese la dirección del receptor');
                if(!receiver.commune) return this.Info('Ingrese la comuna del receptor');

                this.$set(this.modalCertificationFactura.step2.fieldsReceiver, 'rut', Util.Rut(receiver.rut));
            }

            let details = step2.fieldsDetails;
            let errForeach = null;
            details.forEach( ({items}, index) => {
                if (Object.keys(items).length > 0) {
                    items.forEach(item => {
                        if(!item.item || item.item == '') return errForeach = `El ítem del caso ${index+1} no posee nombre`; 
                        if(!item.quantity || item.quantity < 0) return errForeach = `El ítem del caso ${index+1} debe tener una cantidad válida`; 
                        if(!item.price || item.price < 0) return errForeach = `El ítem del caso ${index+1} debe tener un precio válido`; 
                    });
                }
            });
            if(errForeach) return this.Info(errForeach);

            this.Loading();
            axios.post(`/sii/${this.Local.id}/simulation`, step2).then( ({data}) => {
                if(data.status){
                    this.$set(this.modalCertificationFactura.step2, 'track_id', data.track_sobre);
                    this.$set(this.modalCertificationFactura.step2, 'zip', data.zip);
                } 

                return this.Info(data.message);
            }).catch(err => {
                this.Response(err);
            });
        },
        Exchange(){
            if(!this.modalCertificationFactura.step3.file) return this.Info('Es obligatorio ingresar el documento xml');
            
            let formData = new FormData();
            formData.append("file", this.modalCertificationFactura.step3.file);

            this.Loading();
            axios.post(`/sii/${this.Local.id}/exchange`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then( ({data}) => {
                if(data.status){
                    this.$set(this.modalCertificationFactura.step3, 'zip', data.zip);
                }
                
                return this.Info(data.message);
            }).catch(err => {
                this.Response(err);
            });
        },
        loadFieldsStep2(){
            let fieldsDetails = [];

            for (let i = 1; i <= 18; i++) {
                fieldsDetails.push({items: []});
            }

            let fieldsReceiver = {};
            this.$set(this.modalCertificationFactura, 'step2', {
                fieldsDetails : fieldsDetails , 
                fieldsReceiver : fieldsReceiver
            });
        },
        UseSharedFolios(option)
        {
            this.Loading();
            axios.patch(`/sii/${this.Local.id}/folios/shared`, {shared_folios: option}).then(res => {
                this.Response(res);
                this.general = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        AddActeco(){
            if(!this.modalGeneral.actecoSelected) return;
            let exist = this.modalGeneral.actecos.find( acteco => acteco == this.modalGeneral.actecoSelected);
            if(exist) return;
            if(this.modalGeneral.actecos.length >= 4) return this.Info('Se pueden registrar máximo 4 actividades económicas');
            this.modalGeneral.actecos.push(this.modalGeneral.actecoSelected);
        },
        AddPaymentMethod(method, from){
            let tmpModalGeneral = this.modalGeneral[from];
        
            let exist = tmpModalGeneral.find( ban_method => ban_method == method);
            if(exist) return;
            
            tmpModalGeneral.push(method);
        },
        OpenResendBoletas()
        {
            var today = this.Util.Date('now', 'DD/MM/YYYY');
            this.modalResendBoletas = {
                start: '00:00:00 '+today,
                finish: '23:59:59 '+today
            };
        },
        ResendBoletas() 
        {
            this.Loading();
            axios.post(`/sii/${this.Local.id}/boletas/resend`, this.modalResendBoletas).then(res => {
                this.Info(res.data.triggered ? `Se reenviaron ${res.data.count} boletas` : `Se encontraron ${res.data.count} boletas no recibidas por el SII`);
                if(res.data.count)
                {
                    this.$set(this.modalResendBoletas, 'log', res.data.log);
                    this.$set(this.modalResendBoletas, 'count', res.data.count);
                    this.$set(this.modalResendBoletas, 'resend', !res.data.triggered);
                }
                else
                {
                    this.$set(this.modalResendBoletas, 'log', '');
                    this.$set(this.modalResendBoletas, 'count', 0);
                    this.$set(this.modalResendBoletas, 'resend', false);
                }
            }).catch(err => {
                this.Response(err);
            });
        }
    }
}
</script>
<style>
.table-certification, 
.table-certification-step2, 
.table-certification tr, 
.table-certification-step2 tr, 
.table-certification input, 
.table-certification-step2 input {
    width: 100%;
}
.table-certification td {
    border-bottom: 1px solid whitesmoke;
}
.table-certification th, .table-certification-step2 th{
    text-align: left;
}
.table-certification td, .table-certification-step2 td{
    width: 25%;
}
</style>
